module.exports = __webpack_public_path__ + "static/media/wedding.90d27633.jpg";